var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBulkUploadLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 21,
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#C4C4C4"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 17.2609V9.08696C1 7.98239 1.89543 7.08696 3 7.08696H12.913C14.0176 7.08696 14.913 7.98239 14.913 9.08696V17.2609C14.913 18.3654 14.0176 19.2609 12.913 19.2609H3C1.89543 19.2609 1 18.3654 1 17.2609Z",
  strokeWidth: 1.5,
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9135 16.2174H15.957C17.0616 16.2174 17.957 15.322 17.957 14.2174V6.04348C17.957 4.93891 17.0616 4.04348 15.957 4.04348H6.04394C4.93937 4.04348 4.04395 4.93891 4.04395 6.04348V7.08696",
  strokeWidth: 1.5,
  fill: "none"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3913 13.1739H19C20.1045 13.1739 21 12.2785 21 11.1739V3C21 1.89543 20.1045 1 19 1H9.08691C7.98234 1 7.08691 1.89543 7.08691 3V3.6087",
  strokeWidth: 1.5,
  fill: "none"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.04537 9.60869C8.04537 11.0016 8.04537 12.0807 8.04537 13.1678M8.04537 16.5652C8.04537 15.2414 8.04537 14.201 8.04537 13.1678M8.04537 13.1678C9.36912 13.1678 11.435 13.1678 11.435 13.1678M8.04537 13.1678H4.47852",
  strokeWidth: 1.5,
  fill: "none"
})));
export default SvgBulkUploadLarge;